import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map, withLatestFrom } from "rxjs/operators";

import { selectHaveFeatureFlagsBeenFetched } from "@app/shared/state/feature-flag/feature-flag.selectors";
import { selectShouldHaveAccessToDiscontinuedProducts } from "./discontinued-products.selectors";

export const discoProductsGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(selectHaveFeatureFlagsBeenFetched).pipe(
    withLatestFrom(store.select(selectShouldHaveAccessToDiscontinuedProducts)),
    filter(([flagsFetched]) => flagsFetched),
    map(([, flagIsActive]) =>
      flagIsActive ? true : router.parseUrl("/unauthorized"),
    ),
  );
};
